import React from 'react';
/*
import {
  hf,
  hfDTM,
  _ht,
  cr,
  a,
  ls,
  f,
  gs,
  useLdrz,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  MsgC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as _ht from './_ht';

import * as icvI1z___Ti from './icvI1z___Ti';

export const N = (pz: {
  sPz: _ht.dz,
  pagez: _ht.dz,
}) => {

  const _frcUdt = ls.frcUdt();

//hf.l(`icvI1zS10To 28: here`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [
                  ]
                },
                {
                  oClds: [
                    cr.c(TextC.N, {
                      key: -20,
                      abtType: 'ftnCmnz',
                    }),
                    cr.c(icvI1z___Ti.S, {
                      key: -10,
                      sPz: pz.sPz,
                      frcUdt: _frcUdt,
                      pagez: pz.pagez,
                    })
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(icvI1z___Ti.B, {
          key: -20,
          sPz: pz.sPz,
          cz: {
            dffz: pz.sPz.crt.dffz,
          },
          pagez: pz.pagez,
        }),

        cr.c(MsgC.N, {
          key: -40,
          abtType: 'cttCmnz',
          boxStlz: a('dw/120 mb/2 mt/2'),
          cz: {
            ls: [
              {
                mkrCz: {
                  textz: {
                    pfx: `■`
                  }
                },
                msgCz: {
                  textz: {
                    pfx: `［確認］ボタン　→　各${pz.sPz.crt.dffz.tgt}の【詳細確認・変更・削除】画面に移動`
                  }
                }
              },
              pz.sPz.crt.ctt == 'r' ?
              {
                mkrCz: {
                  textz: {
                    pfx: `■`
                  }
                },
                msgCz: {
                  textz: {
                    pfx: '[書類]アイコン　→　「利用申請書」・「利用許可書・領収書」'
                  }
                }
              }
              : null,
            ]
          },
        }),

        cr.c(icvI1z___Ti.L, {
          key: -50,
          sPz: pz.sPz,
          frcUdt: _frcUdt,
          pagez: pz.pagez,
        })

      ]
    })
  );
};
